import React, { useEffect, useState } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import axios from "axios";
import FullScreenLoader from "./Commponents/Comman/FullScreenLoader";


const ProtecteRoutes = () => {

  const token = localStorage.getItem("token");
  const [status, setStatus] = useState(null);
  const location = useLocation();



  // console.log('token11111',localStorage.getItem("token"));
  const verifyJWTToken = async () => {
    try {

      if (localStorage.getItem("token")) {
        // console.log('token222222222222',token);
        await axios.post(process.env.REACT_APP_BACKEND_LINK, {
          method: "verify",
          submethod: "jwtuser",
          key: process.env.REACT_APP_KEY,
          token: localStorage.getItem("token")
        }).then(res => {
          // console.log('res.data?.status', res.data?.status);

          if (res.data?.status && (res.data?.status === true || res.data?.status === "true")) {
            setStatus(true);
          } else {
            setStatus(false);
          }
        });
      } else {
        setStatus(false);
      }
    } catch (err) {
      console.log("err : ", err);
      setStatus(false);
    }
  }

  useEffect(() => {
    verifyJWTToken();
  }, [token]); // ✅ FIX

  // ✅ Handle loading state
  if (status === null) {
    return (
      <FullScreenLoader
        message="Loading..."
        subtext="Please wait while we verify your session"
      />
    );
  }
  console.log("status", status);

  return status ? <Outlet /> : <Navigate to="/" state={{ from: location }} replace />;
};

export default ProtecteRoutes;
